import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Select,
  Textarea,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { mutateFunction } from '../../libs/apis';
import { CustomToast } from '../toast/CustomToast';

const ReportPostModal = ({ isOpen, onClose, post }) => {
  const [reason, setReason] = useState('');
  const [additionalDetails, setAdditionalDetails] = useState('');
  const { addToast } = CustomToast();

  const { mutate, isLoading } = useMutation(mutateFunction);

  const reportReasons = [
    { value: 'spam', label: 'Spam or misleading content' },
    { value: 'harassment', label: 'Harassment or bullying' },
    { value: 'hate_speech', label: 'Hate speech or offensive content' },
    { value: 'violence', label: 'Violence or dangerous content' },
    { value: 'copyright', label: 'Copyright violation' },
    { value: 'other', label: 'Other' },
  ];

  const handleSubmit = () => {
    if (!reason) {
      addToast('Please select a reason for reporting', 'error', 'top', 2000);
      return;
    }

    mutate(
      {
        key: 'post/report',
        method: 'post',
        data: {
          post_id: post?.id,
          reason,
          ...(additionalDetails && { details: additionalDetails }),
        },
      },
      {
        onSuccess: (res) => {
          addToast('Post has been reported successfully', 'success', 'top');
          setReason('');
          setAdditionalDetails('');
          onClose();
        },
        onError: (err) => {
          addToast(
            err?.response?.data?.message || 'Failed to report post',
            'error',
            'top',
          );
        },
      },
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        w={{ base: '90vw', sm: '400px', md: '500px' }}
        maxW={{ base: '95vw', sm: '400px', md: '500px' }}
        mx={{ base: 2, sm: 'auto' }}
        px={{ base: 2, sm: 0 }}
      >
        <ModalHeader fontSize={{ base: 'lg', sm: 'xl' }}>
          Report Post
        </ModalHeader>
        <ModalBody pb={4}>
          <FormControl isRequired mb={4}>
            <FormLabel fontSize={{ base: 'sm', sm: 'md' }}>
              Reason for reporting
            </FormLabel>
            <Select
              placeholder="Select a reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              fontSize={{ base: 'sm', sm: 'md' }}
            >
              {reportReasons.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel fontSize={{ base: 'sm', sm: 'md' }}>
              Additional details (optional)
            </FormLabel>
            <Textarea
              placeholder="Please provide any additional information that will help us understand the issue"
              value={additionalDetails}
              onChange={(e) => setAdditionalDetails(e.target.value)}
              rows={4}
              fontSize={{ base: 'sm', sm: 'md' }}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            fontSize={{ base: 'sm', sm: 'md' }}
          >
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={handleSubmit}
            isLoading={isLoading}
            fontSize={{ base: 'sm', sm: 'md' }}
          >
            Submit Report
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReportPostModal;
